<template>
    <!-- 汉字详情页面 -->
    <div class="chars-detail">
        <!-- 汉字详情 -->
        <div class="chars-container">
            <!-- 汉字信息 -->
            <div class="info">
                <!-- 汉字 -->
                <div class="char">{{char.content}}</div>
                <!-- 拼音 -->
                <div class="spell info-item">
                    <div class="key">拼音</div>
                    <div class="value">{{char.spell}}</div>
                </div>
                <!-- 部首 -->
                <div class="radical info-item">
                    <div class="key">部首</div>
                    <div class="value">{{char.radical}}</div>
                </div>
                <!-- 笔画 -->
                <div class="num info-item">
                    <div class="key">笔画</div>
                    <div class="value">{{char.num}}</div>
                </div>
                <!-- 发音 -->
                <div class="speak info-item">
                    <div class="key">发音</div>
                    <div class="value">{{char.speak}}</div>
                </div>
                <!-- 笔顺 -->
                <div class="speak info-item">
                    <div class="key">笔顺</div>
                    <div class="value">{{char.orders}}</div>
                </div>
                <!-- 详细解释 -->
                <div class="detail info-item">
                    <div class="key">解释</div>
                    <div class="value" v-html="char.detail"></div>
                </div>
            </div>

            <!-- 动画 -->
            <div id="animation" v-if="hasAnimation">
            </div>
        </div>
    </div>
</template>

<script>
    import {GetCharsById} from "@/request/chars";
    import HanziWriter from 'hanzi-writer';
    export default {
        name: "CharsDetail",
        created(){
            // TODO 1. 指定导航栏类型
            this.$store.commit("nav/typeUpdate",3);
            // TODO 2. 获取参数
            this.id = this.$route.params.id;
            // TODO 3. 发送请求获取数据
            GetCharsById({
                id:this.id
            }).then(res => {
                if (res.code === 200){
                    this.char = res.data.chars;
                    let font = this.char.content;
                    // TODO 被挂载时渲染文字
                    var writer = HanziWriter.create('animation', font, {
                        width: 150,
                        height: 150,
                        padding: 5,
                        onLoadCharDataError:() =>{
                            // 没有动画
                            this.hasAnimation = false;
                        }
                    });
                    writer.loopCharacterAnimation()
                }
            })
        },
        mounted(){

        },
        data(){
            return{
                // 汉字对象
                char:{
                    id:"",
                    content:"",
                    spell:"",
                    radical:"",
                    num:"",
                    speak:"",
                    orders:"",
                    detail:""
                },
                id:"",
                hasAnimation:true
            }
        }
    }
</script>

<style scoped lang="less">
    .chars-detail{
        margin: 93px auto;
        .chars-container{
            margin: 25px auto;
            width: 65%;
            background-color: white;
            box-sizing: border-box;
            padding: 35px;
            display: flex;
            justify-content: flex-start;
            box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
            border-radius: 6px;
            /* 信息 */
            .info{
                width: 70%;
                /* 汉字 */
                .char{
                    font-size: 28px;
                    font-weight: bold;
                    margin-bottom: 20px;
                }
                /* 其他信息 */
                .info-item{
                    display: flex;
                    justify-content: flex-start;
                    flex-wrap: wrap;
                    margin-bottom: 20px;
                    /* 属性 */
                    .key{
                        font-size: 16px;
                        font-weight: bold;
                        color: #c04851;
                        width: 8%;
                    }
                    /* 值 */
                    .value{
                        margin-left: 25px;
                        color: #606266;
                        letter-spacing: 1px;
                        line-height: 25px;
                        width: 70%;
                    }
                }
            }
            /* 动画 */
            #animation{
                width: 185px;
                height: 185px;
                background-image: url("../../../assets/tian.png");
                background-size: cover;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }

    }
</style>